// @flow

import * as React from "react";
import {css, StyleSheet} from "aphrodite";

const Spring = () => (
    <span className={css(styles.spring)}></span>
);

const styles = StyleSheet.create({
    spring: {
        flexGrow: 1,
    },
});

export default Spring;
